import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bnt-imprimir',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bnt-imprimir.component.html',
  styleUrls: ['./bnt-imprimir.component.scss'],
})
export class BntImprimirComponent {
  /**
   * Controla se o botão está desabilitado
   */
  @Input() disabled: boolean = false;
  /**
   * Texto do botão
   */
  @Input() label: string = '';
  /**
   * Caminho do ícone
   */
  @Input() icon: string = '';
  /**
   * Evento disparado ao clicar
   */
  @Output() imprimir = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.imprimir.emit();
    }
  }
}
